import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './createApiSlice'
import authReducer from "./user/authentication/authSlice"
import { authApiSlice } from "./user/authentication/authApiSlice"

import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import {encryptTransform} from 'redux-persist-transform-encrypt';
import gridFilterSlice from './global/filter/gridFilterSlice'
import gridFilterBuilderRuleSlice from './global/filter/builder/gridFilterBuilderRuleSlice'
import gridFilterBuilderSettingsSlice from './global/filter/builder/gridFilterBuilderSettingsSlice'
import userLayoutSlice from './global/userLayout/userLayoutSlice'
import {storeEncryptor} from './transforms/global';
import generalSlice from './global/generalSlice'
import { generalTransform } from './transforms/individual'
import { loginMiddleware } from './middleware/loginMiddleware'
import { tableSettingsMiddleware } from './middleware/tableSettingsMiddleware'
import progressionTabSlice from './global/progressionTabSlice'
import warehouseSlice from './warehouse/warehouseSlice'
import { rootSlice } from './createRootSlice'
import { subscribeToAuthSync } from './authSync'
import settingsSlice from './global/settingsSlice'
import { reduxMigrations } from './migrations'
import tabViewSlice from './global/tabViewSlice'
import { etailizeApiSlice } from './webshop/etailizeSlice';
import relationDashboardSlice from './global/relation/state/relationDashboardSlice';
import daytotalsStateSlice from './reports/fulfillment/state/daytotalsState';
import actionProgressSlice from './global/actionProgressSlice';
// Import table settings slice to register endpoints with main apiSlice
import './global/tableSettings/tableSettingsSlice';
// Import PWA slice to register endpoints with main apiSlice
import './pwa/pwaSlice';
// Import subscription slice to register endpoints with main apiSlice
import './subscription/subscriptionSlice';
// Import brand slice to register endpoints with rootSlice
import './global/brandRootSlice';
// Import news slice to register endpoints with rootSlice
import './global/newsRootSlice';
import { uptimeRobotApi } from './uptimebot/uptimeRobotSlice';
import { mfaApiSlice } from "./user/mfaSlice";
import reportFilterSlice from './global/filter/reportFilterSlice';

// storeEncryptor
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth','settings','views', 'gridFilter', 'reportFilter', 'general', 'warehouse', 'progressiontabs', 'actionProgress', 'userLayout'],

    version: 3, // Make sure this matches the highest migration version
    migrations: createMigrate(reduxMigrations, { debug: false }),

    //Order of operations important, the encryptor needs to be LAST
    transforms: [
      generalTransform,
      storeEncryptor
    ]
};

  
const rootReducer = combineReducers({
    [apiSlice.reducerPath] : apiSlice.reducer,
    [rootSlice.reducerPath] : rootSlice.reducer,
    [uptimeRobotApi.reducerPath]: uptimeRobotApi.reducer,
    [etailizeApiSlice.reducerPath] : etailizeApiSlice.reducer,

    // Api slice is seperate from authapislice, 
    // one interacts with the API, the other with the state
    auth: authReducer,

    //State of sidebar, what env is selected and what menu item is selected
    settings: settingsSlice.reducer,

    views: tabViewSlice.reducer,

    //general slice, saves the state or whatever is in it
    general: generalSlice.reducer,

    //Warehouse slice (warehouse selector)
    warehouse: warehouseSlice.reducer,

    //Progression tab slice
    progressiontabs: progressionTabSlice.reducer,

    //Relation dashboard
    relationDashboard: relationDashboardSlice.reducer,

    dayTotalsReport: daytotalsStateSlice.reducer,

    reportFilter:reportFilterSlice.reducer,

    //gridfilter and the builder
    gridFilter: gridFilterSlice.reducer,
    gridFilterBuilderRule: gridFilterBuilderRuleSlice.reducer,
    gridFilterBuilderSettings: gridFilterBuilderSettingsSlice.reducer,

    //User layout preferences — saved column configs per gridKey, reserved tabConfigs slot for the future
    userLayout: userLayoutSlice.reducer,

    //Action progress tracking for background operations
    actionProgress: actionProgressSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
  
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({
            serializableCheck: {
              // Ignore these action types
              ignoredActions: ['persist/PERSIST']
            }
          })
            .concat(
                apiSlice.middleware,
                authApiSlice.middleware,
                uptimeRobotApi.middleware,
                etailizeApiSlice.middleware,
                mfaApiSlice.middleware,
                loginMiddleware,
                tableSettingsMiddleware
            ),
},window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export const persistor = persistStore(store);

// Adopt tokens refreshed by another tab of this origin, so a rotated refresh
// token in one tab does not log the others out.
subscribeToAuthSync(store);
